/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const isLogin = !!currentUser;
  const isLegacySuperAdmin = !currentUser?.role && currentUser?.club_id == null;
  const isSuperAdmin =
    currentUser?.role === 'super_admin' || isLegacySuperAdmin;

  return {
    // 后台接口当前以 role 区分平台总管理员和俱乐部管理员；
    // 旧库的 admin 账号还没有 role/club_id 字段返回，按历史语义视为平台总管理员。
    canAdmin:
      isLogin &&
      (currentUser.access === 'admin' ||
        !!currentUser.role ||
        isLegacySuperAdmin),
    // 俱乐部管理和俱乐部账号管理涉及跨俱乐部数据，只允许平台总管理员在菜单中看到入口。
    canSuperAdmin: isSuperAdmin,
  };
}
